export const MAX_TASKS_COUNT = 200;
export const MAX_SUBTASKS_COUNT = 200;
export const MAX_DUPLICATES_COUNT = 100;
